export default {
  'xeHentai WebUI': '紳士WebUI',
  'Cancel': '取消',
  'Add': '添加',
  'Confirm': '確定',
  'Configuration': '配置',
  'Task Configuration': '任務設置',
  'Add Task': '添加任務',
  'disconneted': '未連接',
  'Running threads': '運行線程',
  'Zombie threads': '抽風線程',
  'Queued images': '待下載圖片',
  'Finished images': '已下載圖片',
  'Finished': '已完成',
  'Paused': '暫停中',
  'Running': '下載中',
  'Failed': '失敗',
  'Successfully connected to xeHentai': '已連接到xeHentai',
  'Task #{0} {1} failed: {2}': '任務 #{0} {1}操作失敗: {2}',
  'EroHon': '好多本子',
  'Progress': '進度',
  'RPC Error: {0}': 'RPC 請求失敗: {0}',
  'Network Error': '網絡錯誤',
  'Endpoint not set': '沒有配置連接',
  'Forbidden': '密鑰錯誤',
  'Connection Configuration': '連接設置',
  'Server': '伺服器',
  'Host': '主機名',
  'Port': '埠',
  'Secret': '密鑰',
  'Auto Refresh': '自動刷新',
  'Basic Configuration': '基本設置',
  'Advanced Configuration': '高級設置',
  'seconds': '秒',
  'Download directory': '下載目錄',
  'Download original': '下載原圖',
  'Rename': '重命名',
  'Japanese title': '日語標題',
  'Proxy': '代理',
  'Add Proxy': '添加代理',
  'Use proxy': '使用代理',
  'Proxy image only': '僅代理圖片',
  'Make archive': '製作壓縮包',
  'Scan thread': '掃描線程數',
  'Download thread': '下載線程數',
  'Download timeout': '下載超時',
  'Low speed threshold': '低速重試閾值',
  'Ignored errors': '忽略錯誤',
  'Add Errno': '添加錯誤號',
  'Log path': '日誌路徑',
  'Log verbose': '日誌詳細等級',
  'Save tasks': '保存任務',
  'Delete files': '自動刪除文件',
  '"{0}" is not a valid proxy string': '"{0}" 不是合法的代理格式',
  '"{0}" is not a valid error number': '"{0}" 不是合法的錯誤號',
  'Successfully add task #{0}': '成功新建任務 #{0}',
  'Single Page': '單頁模式',
  'Double Page': '雙頁模式',
  'This WebUI don\'t supports xeHentai earlier than {0}': '這個版本的Web界面可能不兼容{0}以前的xeHentai',
  'To add multiple tasks, input one line per URL': '如需添加多個任務，可以每行填寫一條URL',
  'Type to search': '搜索本子'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh-hant.js